import React from "react";
import { useNavigate } from "react-router-dom";
import { clearClientSession } from "../config/auth";
import ButtonBase from "./Buttons";

const PageHeader = ({
  title,
  subtitle,
  backLabel,
  onBack,
  rightAction,
  useDefaultRightAction = false,
  useDefaultLogoutAction = false,
  onDefaultLogout,
  dashboardPath = "/HomePage",
  dashboardLabel = "Dashboard",
  logoutLabel = "Logout",
  defaultActionClassName = "ui-top-action-btn",
  inlineBackTitle = false,
  className = "",
  titleClassName = "",
}) => {
  const navigate = useNavigate();
  const shouldShowBack = typeof onBack === "function" && backLabel !== null;
  const shouldRenderInlineHeader = inlineBackTitle && shouldShowBack && title;

  const handleDefaultLogout = () => {
    if (typeof onDefaultLogout === "function") {
      onDefaultLogout();
      return;
    }

    clearClientSession();
    navigate("/");
  };

  const defaultRightAction = useDefaultRightAction ? (
    <>
      <ButtonBase
        variant="ghost"
        size="sm"
        className={defaultActionClassName}
        onClick={() => navigate(dashboardPath)}
      >
        {dashboardLabel}
      </ButtonBase>
      <ButtonBase
        variant="danger"
        size="sm"
        className={defaultActionClassName}
        onClick={handleDefaultLogout}
      >
        {logoutLabel}
      </ButtonBase>
    </>
  ) : null;

  const defaultLogoutAction = useDefaultLogoutAction ? (
    <ButtonBase
      variant="danger"
      size="sm"
      className={defaultActionClassName}
      onClick={handleDefaultLogout}
    >
      {logoutLabel}
    </ButtonBase>
  ) : null;

  const resolvedRightAction = rightAction ?? defaultRightAction ?? defaultLogoutAction;

  return (
    <div className={`ui-page-header ${className}`.trim()}>
      <div className="ui-page-header__left">
        {shouldRenderInlineHeader ? (
          <div className="ui-page-header__inline">
            <button type="button" className="ui-page-header__back" onClick={onBack}>
              <span aria-hidden="true">&#8592;</span>
              {backLabel ? <span>{backLabel}</span> : null}
            </button>
            <h1 className={`ui-page-header__title ${titleClassName}`.trim()}>{title}</h1>
          </div>
        ) : (
          <>
            {shouldShowBack ? (
              <button type="button" className="ui-page-header__back" onClick={onBack}>
                <span aria-hidden="true">&#8592;</span>
                {backLabel ? <span>{backLabel}</span> : null}
              </button>
            ) : null}

            {subtitle ? <p className="ui-page-header__subtitle">{subtitle}</p> : null}
            {title ? (
              <h1 className={`ui-page-header__title ${titleClassName}`.trim()}>{title}</h1>
            ) : null}
          </>
        )}
      </div>

      {resolvedRightAction ? (
        <div className="ui-page-header__right">{resolvedRightAction}</div>
      ) : null}
    </div>
  );
};

export default PageHeader;
